import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { CombinationPrevention } from '../../../../../core/picks/combo-prevention';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates V1 pick and Betbuilder pick if they are compatible for combo.
 */
export class V1SportBetbuilderComboPrevention extends BaseComboPrevention<BetslipV1Pick, BetslipBetBuilderPick> {
    constructor() {
        super(BetslipV1Pick, BetslipBetBuilderPick);
    }

    private isSameEvent(x: BetslipV1Pick, y: BetslipBetBuilderPick): boolean {
        return x.event.id === y.event.event.id;
    }

    private isSameEventGroup(thisPick: BetslipV1Pick, otherPick: BetslipBetBuilderPick): boolean {
        return (
            thisPick.event.isLive !== otherPick.event.event.isLive &&
            ((thisPick.event.isLive && thisPick.event.groupId == null) ||
                (otherPick.event.event.isLive && otherPick.event.event.groupId == null) ||
                thisPick.event.groupId === otherPick.event.event.groupId)
        );
    }

    private isSameLeague(x: BetslipV1Pick, y: BetslipBetBuilderPick): boolean {
        return (
            x.league.id === y.event.league.id ||
            (x.event.isLive !== y.event.event.isLive &&
                x.league.parentLeagueId != null &&
                y.event.league.parentLeagueId != null &&
                x.league.parentLeagueId === y.event.league.parentLeagueId)
        );
    }

    private isLiveMainMixed(checkingPick: BetslipV1Pick, otherPick: BetslipBetBuilderPick): boolean {
        return checkingPick.event.isLive !== otherPick.event.event.isLive;
    }

    validate(thisPick: BetslipV1Pick, otherPick: BetslipBetBuilderPick): ComboPreventionResult {
        switch (thisPick.market.comboPrevention) {
            case CombinationPrevention.NoCombo:
                return ComboPreventionResult.NoComboAllowed;

            case CombinationPrevention.NoSportCombo:
                if (thisPick.sport.id === otherPick.sportId) {
                    return ComboPreventionResult.SameSport;
                }
                break;
            case CombinationPrevention.NoLeagueCombo:
                if (this.isSameLeague(thisPick, otherPick)) {
                    return ComboPreventionResult.SameLeague;
                }
                break;
            case CombinationPrevention.NoEventCombo:
                if (this.isSameEvent(thisPick, otherPick)) {
                    return ComboPreventionResult.SameEvent;
                }
                break;
            case CombinationPrevention.OnlyDifferentLiveEvents:
                if (this.isSameEventGroup(thisPick, otherPick) || this.isSameEvent(thisPick, otherPick)) {
                    return ComboPreventionResult.SameEventGroup;
                }
                break;
            case CombinationPrevention.OnlyLiveEvents:
                if (
                    (otherPick.market.comboPrevention === CombinationPrevention.NoSportCombo ||
                        otherPick.market.comboPrevention === CombinationPrevention.OnlySameLeagueDifferentEvent ||
                        otherPick.market.comboPrevention === CombinationPrevention.NoFixtureCombo) &&
                    this.isSameEventGroup(thisPick, otherPick)
                ) {
                    return ComboPreventionResult.SameEventGroup;
                }
                break;
            case CombinationPrevention.OnlySameLeagueDifferentEvent: // only within same league but different event!
                if (
                    thisPick.event.id === otherPick.event.event.id ||
                    thisPick.league.id !== otherPick.event.league.id ||
                    this.isLiveMainMixed(thisPick, otherPick)
                ) {
                    return ComboPreventionResult.DifferentLeague;
                }
                break;
        }

        return ComboPreventionResult.AllCombo;
    }
}
